import {createApp} from 'vue'
import Store from 'store'
import options from './TheFooter.options'

const el = '.nlx-component--the-footer'
const DOM = document.querySelector(el)

const component = createApp(options).use(Store)

if(DOM){
    const template = DOM.outerHTML
    options.template = template
    const countrySelector = []
    const currentlySelectedLang = DOM.querySelector('.nlx-the-footer__language-selector-button > SPAN').innerText

    DOM.querySelectorAll('.nlx-the-footer__language-selector-choices-list-item').forEach(link => {
        countrySelector.push({
            href:link.querySelector('A').href,
            displayName:link.querySelector('A').innerText
        })
    })
    
    
    if (currentlySelectedLang) Store.commit('main/set_currently_selected_lang', currentlySelectedLang)
    Store.commit('main/set_country_selector_data',countrySelector)

    component.mount(el)
}

